import React from 'react';

import { Title, Button } from 'components/commons';
import mockupBizContaIcon from 'assets/svg/Mockup_BizConta.svg';
import bizContaLogo from 'assets/svg/biz-conta-logo.svg';
import bizContaTitle from 'assets/svg/biz-conta-title.svg';
import arrowIcon from 'assets/svg/arrows.svg';
import dolarIcon from 'assets/img/dolar.png';
import touchIcon from 'assets/svg/touch.svg';
import qrCodeIcon from 'assets/img/qrcode-desistencia.png';
import googlePlayIcon from 'assets/svg/google-play.svg';
import playStoreIcon from 'assets/svg/play-store.svg';
import './direto/error-message/request-denied-inqueue-layout.scss';

type DesistedLayoutProps = {}

const DesistedLayout: React.FC<DesistedLayoutProps> = ({}) => {
    return (
        <>
            <div className="message-box-container request-denied-inqueue-layout request-desisted-layout ">

                <div className="screen">
                    <div className="message-box">
                        <Title>
                        obg pela sua resposta 😉
                        </Title>

                        <p className="text">
                            Ela é tão importante que temos uma surpresa pra você: que <br className="hidden-sm"/>
                            tal uma conta digital PJ com <b>TED e Pix grátis.</b><br/>
                            <b>A BizConta é isso e muito mais.</b>
                        </p>

                        <div className="request-denied-inqueue-layout__bizconta ">
                            <img src={mockupBizContaIcon} />
                            <ul>
                                <div>
                                    <img src={bizContaLogo} />
                                    <img src={bizContaTitle} />
                                </div>
                                <li> <div><img className="icon-arrows" src={arrowIcon} /></div>TED e Pix grátis</li>
                                <li> <div><img className="icon-dolar" src={dolarIcon} /></div>sem mensalidade</li>
                                <li> <div><img className="icon-touch" src={touchIcon} /></div>fácil e simples de usar</li>
                            </ul>
                            <div className="request-denied-inqueue-layout__apps">
                                <p>disponível gratuitamente para Android e iOS</p>
                                <img className="hidden-sm" src={qrCodeIcon} />
                                <a
                                    id="google-desistencia"
                                    href="https://biz-conta.onelink.me/7nkz?pid=site&c=tela-desistencia&af_adset=baixe-gratis"
                                    target="_blank"
                                >
                                    <img src={googlePlayIcon} />
                                </a>
                                <a
                                    id="apple-desistencia"
                                    href="https://biz-conta.onelink.me/7nkz?pid=site&c=tela-desistencia&af_adset=baixe-gratis"
                                    target="_blank"
                                >
                                    <img src={playStoreIcon} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="request-denied-inqueue-footer">
                <div>
                    <a id="onelink-desistencia" className="request-denied-inqueue-layout-bizconta" href="https://biz-conta.onelink.me/7nkz?pid=site&c=tela-desistencia&af_adset=lojas" target="_blank" >
                        <Button className="request-denied-inqueue-layout-bizconta-button" label="quero minha BizConta" />
                    </a>
                </div>
            </div>
        </>
    )
};

export default DesistedLayout;
